import * as fromDatatype from '../datatype-library';

export interface bl_cms_topic_subscription_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_topic_subscription_event_RowClass implements bl_cms_topic_subscription_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
